import { DASH_PENDING_CANCELLATIONS_GRID_CONFIG } from '@apps-common/apps/portal/pages/dashboard/components/pending-cancellations/pending-cancellations-grid-layout'
import { DASH_PINNED_UNITS_GRID_CONFIG } from '@apps-common/apps/portal/pages/dashboard/components/pinned-units/pinned-units-grid-layout'
import { DASH_RECENT_ACTIVATIONS_GRID_CONFIG } from '@apps-common/apps/portal/pages/dashboard/components/recent-activations/recent-activations-grid-layout'
import { DASH_RECENT_CANCELLATIONS_GRID_CONFIG } from '@apps-common/apps/portal/pages/dashboard/components/recent-cancellations/recent-cancellations-grid-layout'
import { DASH_RECENT_ORDERS_GRID_CONFIG } from '@apps-common/apps/portal/pages/dashboard/components/recent-orders/recent-orders-grid-layout'
import { DASH_TOTAL_ACTIVATIONS_KPI_GRID_CONFIG } from '@apps-common/apps/portal/pages/dashboard/components/total-activations-kpi/total-activations-kpi-grid-layout'
import { DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG } from '@apps-common/apps/portal/pages/dashboard/components/total-active-kpi/total-active-kpi-grid-layout'
import { DASH_TOTAL_CANCELLATIONS_KPI_GRID_CONFIG } from '@apps-common/apps/portal/pages/dashboard/components/total-cancellations-kpi/total-cancellations-kpi-grid-layout'
import { DASH_TOTAL_PENDING_CANCELLATION_KPI_GRID_CONFIG } from '@apps-common/apps/portal/pages/dashboard/components/total-pending-cancellation-kpi/total-pending-cancellation-kpi-grid-layout'

export const DASH_GRID_LAYOUT = {
  xl: [
    DASH_PINNED_UNITS_GRID_CONFIG.layout.xl,
    DASH_RECENT_ORDERS_GRID_CONFIG.layout.xl,
    DASH_RECENT_ACTIVATIONS_GRID_CONFIG.layout.xl,
    DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG.layout.xl,
    DASH_TOTAL_ACTIVATIONS_KPI_GRID_CONFIG.layout.xl,
    DASH_TOTAL_PENDING_CANCELLATION_KPI_GRID_CONFIG.layout.xl,
    DASH_TOTAL_CANCELLATIONS_KPI_GRID_CONFIG.layout.xl,
    DASH_PENDING_CANCELLATIONS_GRID_CONFIG.layout.xl,
    DASH_RECENT_CANCELLATIONS_GRID_CONFIG.layout.xl
  ],
  lg: [
    DASH_PINNED_UNITS_GRID_CONFIG.layout.lg,
    DASH_RECENT_ORDERS_GRID_CONFIG.layout.lg,
    DASH_RECENT_ACTIVATIONS_GRID_CONFIG.layout.lg,
    DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG.layout.lg,
    DASH_TOTAL_ACTIVATIONS_KPI_GRID_CONFIG.layout.lg,
    DASH_TOTAL_PENDING_CANCELLATION_KPI_GRID_CONFIG.layout.lg,
    DASH_TOTAL_CANCELLATIONS_KPI_GRID_CONFIG.layout.lg,
    DASH_PENDING_CANCELLATIONS_GRID_CONFIG.layout.lg,
    DASH_RECENT_CANCELLATIONS_GRID_CONFIG.layout.lg
  ],
  md: [
    DASH_PINNED_UNITS_GRID_CONFIG.layout.md,
    DASH_RECENT_ORDERS_GRID_CONFIG.layout.md,
    DASH_RECENT_ACTIVATIONS_GRID_CONFIG.layout.md,
    DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG.layout.md,
    DASH_TOTAL_ACTIVATIONS_KPI_GRID_CONFIG.layout.md,
    DASH_TOTAL_PENDING_CANCELLATION_KPI_GRID_CONFIG.layout.md,
    DASH_TOTAL_CANCELLATIONS_KPI_GRID_CONFIG.layout.md,
    DASH_PENDING_CANCELLATIONS_GRID_CONFIG.layout.md,
    DASH_RECENT_CANCELLATIONS_GRID_CONFIG.layout.md
  ],
  sm: [
    DASH_PINNED_UNITS_GRID_CONFIG.layout.sm,
    DASH_RECENT_ORDERS_GRID_CONFIG.layout.sm,
    DASH_RECENT_ACTIVATIONS_GRID_CONFIG.layout.sm,
    DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG.layout.sm,
    DASH_TOTAL_ACTIVATIONS_KPI_GRID_CONFIG.layout.sm,
    DASH_TOTAL_PENDING_CANCELLATION_KPI_GRID_CONFIG.layout.sm,
    DASH_TOTAL_CANCELLATIONS_KPI_GRID_CONFIG.layout.sm,
    DASH_PENDING_CANCELLATIONS_GRID_CONFIG.layout.sm,
    DASH_RECENT_CANCELLATIONS_GRID_CONFIG.layout.sm
  ],
  xs: [
    DASH_PINNED_UNITS_GRID_CONFIG.layout.xs,
    DASH_RECENT_ORDERS_GRID_CONFIG.layout.xs,
    DASH_RECENT_ACTIVATIONS_GRID_CONFIG.layout.xs,
    DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG.layout.xs,
    DASH_TOTAL_ACTIVATIONS_KPI_GRID_CONFIG.layout.xs,
    DASH_TOTAL_PENDING_CANCELLATION_KPI_GRID_CONFIG.layout.xs,
    DASH_TOTAL_CANCELLATIONS_KPI_GRID_CONFIG.layout.xs,
    DASH_PENDING_CANCELLATIONS_GRID_CONFIG.layout.xs,
    DASH_RECENT_CANCELLATIONS_GRID_CONFIG.layout.xs
  ],
  xxs: [
    DASH_PINNED_UNITS_GRID_CONFIG.layout.xxs,
    DASH_RECENT_ORDERS_GRID_CONFIG.layout.xxs,
    DASH_RECENT_ACTIVATIONS_GRID_CONFIG.layout.xxs,
    DASH_TOTAL_ACTIVE_KPI_GRID_CONFIG.layout.xxs,
    DASH_TOTAL_ACTIVATIONS_KPI_GRID_CONFIG.layout.xxs,
    DASH_TOTAL_PENDING_CANCELLATION_KPI_GRID_CONFIG.layout.xxs,
    DASH_TOTAL_CANCELLATIONS_KPI_GRID_CONFIG.layout.xxs,
    DASH_PENDING_CANCELLATIONS_GRID_CONFIG.layout.xxs,
    DASH_RECENT_CANCELLATIONS_GRID_CONFIG.layout.xxs
  ]
}
